import {
  Route,
  UpdateUpsellCategory,
  UpsellCategory,
  populateRoute,
} from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"
import { request } from "../api"

const upsellQueries = {
  all: () => ["upsell"],
  categories: () =>
    queryOptions({
      queryKey: [...upsellQueries.all(), "categories"],
      queryFn: () =>
        request<UpsellCategory[]>({
          url: Route.UPSELL__CATEGORIES,
          method: "GET",
        }),
    }),
}

export default upsellQueries

export function useUpdateUpsellCategory() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      categoryId,
      data,
    }: {
      categoryId: string
      data: UpdateUpsellCategory
    }) =>
      request<UpsellCategory>({
        url: populateRoute(Route.UPSELL__ADMIN_CATEGORY, categoryId),
        method: "PUT",
        data,
      }),
    onSuccess: (updated) =>
      queryClient.setQueryData(
        upsellQueries.categories().queryKey,
        (previous: UpsellCategory[] | undefined) =>
          previous?.map((category) =>
            category.id === updated.id ? updated : category,
          ),
      ),
  })
}
